import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";
import { Spinner } from "../components/common";
import { apiError } from "../lib/api";

export default function AuthCallback() {
  const { loginWithSession } = useAuth();
  const nav = useNavigate();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const params = new URLSearchParams(window.location.hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");
    window.history.replaceState(null, "", window.location.pathname);
    if (!sessionId) { nav("/login", { replace: true }); return; }
    loginWithSession(sessionId)
      .then(() => { toast.success("Signed in with Google"); nav("/", { replace: true }); })
      .catch((err) => { toast.error(apiError(err)); nav("/login", { replace: true }); });
  }, [loginWithSession, nav]);

  return <div className="min-h-screen bg-[#0B1120]" data-testid="auth-callback"><Spinner label="Signing you in…" /></div>;
}
